module.exports =
  '_ROUND_DETAIL':
    "TITLE": 'Round detail'
    "INFO":
      'COMPETITORS': 'Competitors'
    "MEMO":
      "TITLE": "Memo"
    'TOTAL':
      'OB': 'OB'
      'SAND_SAVES': 'Sand Saves'
      'WATER_HAZARD': 'Water'
    'PLAYERS_ANALYSIS':
      'PAR_ON': "GIR (%)"
      'BOGEY_ON': "GIR+1 (%)"
      'AVG_PUTT': 'Avg. Putts'
      'AVG_PAR_ON_PUTT_CNT': 'GIR. Avg. Putts'
      'RAT_UNDER_EAGLE': 'Eagle or under (%)'
      'RAT_BIRDIE': 'Birdie (%)'
      'RAT_PAR': 'Par (%)'
      'RAT_BOGEY': 'Bogey (%)'
      'RAT_DBOGEY': 'Double Bogey (%)'
      'RAT_OVER_TBOGEY': 'Triple Bogey or over (%)'
      'AVG_SHOT_PAR3': 'Avg. Stroke[Par 3]'
      'AVG_SHOT_PAR4': 'Avg. Stroke[Par 4]'
      'AVG_SHOT_PAR5': 'Avg. Stroke[Par 5]'
      'RAT_RECOVERY': 'Recovery (%)'
      'RAT_SAND_SAVE': 'Sand Saves  (%)'
      'RAT_FAIRWAY_CENTER': 'Fairway hit (%)'
      'RAT_FAIRWAY_LEFT': 'Missed left (%)'
      'RAT_FAIRWAY_RIGHT': 'Missed right (%)'





// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/i18n/en.coffee